// The locked story timeline. Each scene maps to a moment in the kitchen's day.
export const SCENES = [
  { id: "hero", time: "06:58", label: "AM" },
  { id: "deliveries", time: "07:00", label: "AM" },
  { id: "complexity", time: "09:30", label: "AM" },
  { id: "one-action", time: "11:00", label: "AM" },
  { id: "connects", time: "11:45", label: "AM" },
  { id: "service", time: "12:00", label: "PM" },
  { id: "close", time: "06:00", label: "PM" },
];

export const IMG = {
  hero: "/generated/hero_opening.webp",
  deliveries: "/generated/deliveries.webp",
  complexity: "/generated/complexity.webp",
  oneAction: "/generated/one_action.webp",
  service: "/generated/service_plating.webp",
  close: "/generated/evening_close.webp",
};
